<template>
  <div class="block-wrapper">

    <block
      :data="pcXfqfGoodsAdv"
      :url="'recommend-goods?type=5'"
    ></block>

    <block
      :data="pcZyypGoodsAdv"
      :url="'recommend-goods?type=2'"
    ></block>

    <!--惠民大健康-->
    <block
      :data="pcHmdjkGoodsAdv"
      :url="pcHmdjkGoodsAdv.advList[0].url || ''"
    ></block>

    <block
      :data="pcZlyyGoodsAdv"
    ></block>

  </div>
</template>

<script>
  import block from './block'

  export default {
    props: [
      'pcXfqfGoodsAdv',
      'pcZyypGoodsAdv',
      'pcHmdjkGoodsAdv',
      'pcZlyyGoodsAdv',
    ],
    components: {
      block,
    }
  }
</script>

<style scoped lang="less">
  .block-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?1f4a10f3